module.exports = __webpack_public_path__ + "img/list.03f60767.jpg";